import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { autoPromptsAPI } from '../services/api';
import toast from 'react-hot-toast';

const ClaimAutoPrompt = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    const run = async () => {
      if (!currentUser) {
        // Redirect to login and preserve claim path
        const next = encodeURIComponent(`/auto-prompts/claim/${token}`);
        navigate(`/login?next=${next}`);
        return;
      }

      try {
        const res = await autoPromptsAPI.claimWithToken(token);
        toast.success(res.data?.message || 'Claimed');
      } catch (err) {
        console.error('Claim failed', err);
        toast.error(err.response?.data?.error || 'Failed to claim');
      } finally {
        navigate('/');
      }
    };
    run();
  }, [token, navigate, currentUser]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-12 text-center text-gray-600">
      Processing claim...
    </div>
  );
};

export default ClaimAutoPrompt;

